import { InputSwitch } from '@creditornot/cb-switch';
import React from 'react';
import { Field, useFormState } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { RFFFieldErrorWrapper } from 'common/components';
import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';
import { useIsWoltSpecialsInListingManagerEnabled } from 'modules/shared-menu/hooks/useIsWoltSpecialsInListingManagerEnabled';

import { BaseField } from './types';
import { FormRowRenderer } from '../FormRowRenderer';
import { AvailabilityDetails, FormValues } from '../types';

type EnableWoltPlusProps = BaseField & { woltSpecialsCategoryId?: string };

export const EnableWoltPlus = ({ sidePanelMode, offer, woltSpecialsCategoryId }: EnableWoltPlusProps) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const { values } = useFormState<FormValues>();
  const intl = useIntl();

  const { isWoltSpecialsInListingManagerEnabled } = useIsWoltSpecialsInListingManagerEnabled();

  const previewComponent = offer?.wolt_plus_only ? (
    <FormattedMessage id="menu-item.wolt-plus-only.yes" />
  ) : (
    <FormattedMessage id="menu-item.wolt-plus-only.no" />
  );

  const editComponent = (
    <Field<AvailabilityDetails['isWoltPlusOnly']> name="isWoltPlusOnly">
      {field => (
        <RFFFieldErrorWrapper field={field}>
          {input => (
            <InputSwitch
              checked={input.value}
              disabled={!menuPermissions.contentEdit}
              onChange={() => {
                const newValue = !input.value;
                input.onChange(newValue);
              }}
            />
          )}
        </RFFFieldErrorWrapper>
      )}
    </Field>
  );

  const isWoltSpecialsCategory =
    typeof woltSpecialsCategoryId === 'string' && values.categoryId === woltSpecialsCategoryId;

  if (!isWoltSpecialsInListingManagerEnabled || !isWoltSpecialsCategory) {
    return null;
  }

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'menu-item.wolt-plus-only.label' })}
      previewComponent={previewComponent}
      editComponent={editComponent}
      shouldDisplayCreateTag={!values.isWoltPlusOnly}
      sidePanelMode={sidePanelMode}
      offer={offer}
    />
  );
};
